export interface GlowFilterUniforms {
	distance: number;
	glowColor: number[];
	outerStrength: number;
	innerStrength: number;
}

export class GlowFilter extends PIXI.Filter<GlowFilterUniforms> {

	constructor(distance: number = 10, outerStrength: number = 4, innerStrength: number = 0, color: number = 0xffffff, quality: number = 0.1) {
		const vertexSrc: string = '';
		const fragmentSrc: string = 'varying vec2 vTextureCoord;\n' +
			'varying vec4 vColor;\n' +
			'\n' +
			'uniform sampler2D uSampler;\n' +
			'\n' +
			'uniform float distance;\n' +
			'uniform float outerStrength;\n' +
			'uniform float innerStrength;\n' +
			'uniform vec4 glowColor;\n' +
			'uniform vec4 filterArea;\n' +
			'uniform vec4 filterClamp;\n' +
			'const float PI = 3.14159265358979323846264;\n' +
			'\n' +
			'void main(void) {\n' +
			'    vec2 px = vec2(1.0 / filterArea.x, 1.0 / filterArea.y);\n' +
			'    vec4 ownColor = texture2D(uSampler, vTextureCoord);\n' +
			'    vec4 curColor;\n' +
			'    float totalAlpha = 0.0;\n' +
			'    float maxTotalAlpha = 0.0;\n' +
			'    float cosAngle;\n' +
			'    float sinAngle;\n' +
			'    vec2 displaced;\n' +
			'    for (float angle = 0.0; angle <= PI * 2.0; angle += %QUALITY_DIST%) {\n' +
			'       cosAngle = cos(angle);\n' +
			'       sinAngle = sin(angle);\n' +
			'       for (float curDistance = 1.0; curDistance <= %DIST%; curDistance++) {\n' +
			'           displaced.x = vTextureCoord.x + cosAngle * curDistance * px.x;\n' +
			'           displaced.y = vTextureCoord.y + sinAngle * curDistance * px.y;\n' +
			'           curColor = texture2D(uSampler, clamp(displaced, filterClamp.xy, filterClamp.zw));\n' +
			'           totalAlpha += (distance - curDistance) * curColor.a;\n' +
			'           maxTotalAlpha += (distance - curDistance);\n' +
			'       }\n' +
			'    }\n' +
			'    maxTotalAlpha = max(maxTotalAlpha, 0.0001);\n' +
			'\n' +
			'    ownColor.a = max(ownColor.a, 0.0001);\n' +
			'    ownColor.rgb = ownColor.rgb / ownColor.a;\n' +
			'    float outerGlowAlpha = (totalAlpha / maxTotalAlpha)  * outerStrength * (1. - ownColor.a);\n' +
			'    float innerGlowAlpha = ((maxTotalAlpha - totalAlpha) / maxTotalAlpha) * innerStrength * ownColor.a;\n' +
			'    float resultAlpha = (ownColor.a + outerGlowAlpha);\n' +
			'    gl_FragColor = vec4(mix(mix(ownColor.rgb, glowColor.rgb, innerGlowAlpha / ownColor.a), glowColor.rgb, outerGlowAlpha / resultAlpha) * resultAlpha, resultAlpha);\n' +
			'}';

		super(vertexSrc, fragmentSrc
			.replace(/%QUALITY_DIST%/gi, '' + (1 / quality / distance).toFixed(7))
			.replace(/%DIST%/gi, '' + distance.toFixed(7)));

		this.uniforms.glowColor = [0, 0, 0, 1];
		this.distance = distance;
		this.color = color;
		this.outerStrength = outerStrength;
		this.innerStrength = innerStrength;
	}

	public get color(): number {
		return PIXI.utils.rgb2hex(this.uniforms.glowColor);
	}

	public set color(value: number) {
		PIXI.utils.hex2rgb(value, this.uniforms.glowColor);
	}

	public get distance(): number {
		return this.uniforms.distance;
	}

	public set distance(value: number) {
		this.uniforms.distance = value;
	}

	public get outerStrength(): number {
		return this.uniforms.outerStrength;
	}

	public set outerStrength(value: number) {
		this.uniforms.outerStrength = value;
	}

	public get innerStrength(): number {
		return this.uniforms.innerStrength;
	}

	public set innerStrength(value: number) {
		this.uniforms.innerStrength = value;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/display/filters/GlowFilter.ts